import _import_ from "@assets/js/pub_import.js";
const BASE_URL = "tms";
export default [
    {
        path: "/vehicle",
        component: _import_(BASE_URL + "/Vehicle.vue")
    },
    {
        path: "/driver",
        component: _import_(BASE_URL + "/Driver.vue")
    },
    {
        path: "/tmsOrder",
        component: _import_(BASE_URL + "/useCase.vue")
    },
    {
        path: "/doOrders",
        component: _import_(BASE_URL + "/doOrders.vue")
    }
];